/**
 * Paleta de colores estilo Fluent 2 (Microsoft Whiteboard).
 * Los tokens de interfaz viven en styles/theme.css; aquí están los colores de contenido.
 */

export interface Swatch {
  id: string
  hex: string
  name: string
}

/** Colores de tinta / trazo / texto. Fila 1 = básicos, fila 2 = extendidos. */
export const INK_COLORS: Swatch[] = [
  { id: 'black', hex: '#1A1A1A', name: 'Negro' },
  { id: 'gray', hex: '#7A7A7A', name: 'Gris' },
  { id: 'red', hex: '#D13438', name: 'Rojo' },
  { id: 'orange', hex: '#F7630C', name: 'Naranja' },
  { id: 'yellow', hex: '#EAA300', name: 'Amarillo' },
  { id: 'lime', hex: '#73AA24', name: 'Lima' },
  { id: 'green', hex: '#0F7B0F', name: 'Verde' },
  { id: 'teal', hex: '#00A5AA', name: 'Turquesa' },
  { id: 'lightblue', hex: '#3A96DD', name: 'Azul claro' },
  { id: 'blue', hex: '#0F6CBD', name: 'Azul' },
  { id: 'navy', hex: '#003966', name: 'Azul marino' },
  { id: 'purple', hex: '#8764B8', name: 'Morado' },
  { id: 'magenta', hex: '#BF0077', name: 'Magenta' },
  { id: 'pink', hex: '#E3008C', name: 'Rosa' },
  { id: 'brown', hex: '#8E562E', name: 'Café' },
  { id: 'white', hex: '#FFFFFF', name: 'Blanco' },
]

/** Colores de resaltador (se dibujan translúcidos). */
export const HIGHLIGHTER_COLORS: Swatch[] = [
  { id: 'hl-yellow', hex: '#FFF100', name: 'Amarillo' },
  { id: 'hl-lime', hex: '#A4E100', name: 'Lima' },
  { id: 'hl-cyan', hex: '#00E5FF', name: 'Cian' },
  { id: 'hl-pink', hex: '#FF6FBE', name: 'Rosa' },
  { id: 'hl-orange', hex: '#FF9E3D', name: 'Naranja' },
  { id: 'hl-purple', hex: '#B98BFF', name: 'Morado' },
]

/** Colores de nota adhesiva (pastel, como las de Whiteboard). */
export const NOTE_COLORS: Swatch[] = [
  { id: 'n-yellow', hex: '#FEF3A3', name: 'Amarillo' },
  { id: 'n-orange', hex: '#FFD8A8', name: 'Durazno' },
  { id: 'n-pink', hex: '#FFD1E3', name: 'Rosa' },
  { id: 'n-purple', hex: '#E0D5FA', name: 'Lavanda' },
  { id: 'n-blue', hex: '#C9E7FF', name: 'Azul' },
  { id: 'n-teal', hex: '#C3F0E7', name: 'Menta' },
  { id: 'n-green', hex: '#D6F0BE', name: 'Verde' },
  { id: 'n-gray', hex: '#E6E6E6', name: 'Gris' },
]

/** Colores de relleno para figuras (versión suave de la tinta + "sin relleno"). */
export const FILL_COLORS: Swatch[] = [
  { id: 'none', hex: 'none', name: 'Sin relleno' },
  { id: 'f-white', hex: '#FFFFFF', name: 'Blanco' },
  { id: 'f-gray', hex: '#E1E1E1', name: 'Gris' },
  { id: 'f-red', hex: '#FBD9DA', name: 'Rojo' },
  { id: 'f-orange', hex: '#FDE0CE', name: 'Naranja' },
  { id: 'f-yellow', hex: '#FBEECB', name: 'Amarillo' },
  { id: 'f-green', hex: '#D5EDD5', name: 'Verde' },
  { id: 'f-teal', hex: '#CCEFF0', name: 'Turquesa' },
  { id: 'f-blue', hex: '#CFE4F7', name: 'Azul' },
  { id: 'f-purple', hex: '#E7E0F1', name: 'Morado' },
]

/** Colores asignados a los colaboradores (cursores / avatares). */
export const PRESENCE_COLORS = [
  '#0F6CBD',
  '#D13438',
  '#0F7B0F',
  '#8764B8',
  '#F7630C',
  '#00A5AA',
  '#E3008C',
  '#8E562E',
]

export const PEN_SIZES = [1, 2, 4, 6, 10, 16, 24]
export const HIGHLIGHTER_SIZES = [10, 16, 24, 36]

export function presenceColorFor(id: string): string {
  let h = 0
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
  return PRESENCE_COLORS[h % PRESENCE_COLORS.length]
}
